/** Shared helpers for the `~/components/ui` form controls. */

import type { FocusEvent } from "react";

/** Map a raw string to a Select/Checkbox option where the label IS the value. */
export const toValueLabel = (value: string) => ({ value, label: value });

/** Tighter vertical rhythm for `FormItem` when a form packs several fields into a modal or card. */
export const compactFormItemStyle = "mb-3";

/**
 * `NumberField` `onBlur` for a required number: put `fallback` back when the user leaves the field
 * empty. The field reports `null` while empty, which callers ignore (the schemas reject it), so
 * without this the form would keep whatever digit was left before the field was cleared.
 */
export const restoreWhenLeftEmpty =
  (fallback: number, onChange: (value: number) => void, onBlur?: () => void) =>
  (event: FocusEvent<HTMLInputElement>) => {
    if (event.currentTarget.value.trim() === "") onChange(fallback);
    onBlur?.();
  };
